import { type Verlauf, verlaufSchema } from '@nac2s/shared'
import { apiFetch } from './client.js'

/** Der eigene Verlauf — geprüft gegen den Vertrag, nicht nur getypt. */
export async function ladeVerlauf(limit = 50): Promise<Verlauf> {
  return verlaufSchema.parse(await apiFetch(`/api/verlauf?limit=${limit}`))
}
